export default __webpack_public_path__ + "static/media/3.b2faedb0.jpg";